export default __webpack_public_path__ + "static/media/Agarwal.15489aa0.png";